import { motion } from 'framer-motion';
import { BUSINESS_INFO } from '../../constants';
import { dispararConversaoWhatsApp } from '../../utils/gtag';
import './whatsappcta.scss';

export default function WhatsAppCTA() {
  const handleWhatsApp = () => {
    dispararConversaoWhatsApp(() => {
      window.open(BUSINESS_INFO.whatsappUrl, '_blank', 'noopener,noreferrer');
    });
  };

  return (
    <section className="whatsapp-cta">
      <div className="container">
        <motion.div 
          className="whatsapp-cta-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <button onClick={handleWhatsApp} className="btn-whatsapp-green">
            👉 Chamar no WhatsApp agora
          </button>
          <p className="whatsapp-cta-subtitle">
            Resposta rápida • Sem compromisso
          </p>
        </motion.div>
      </div>
    </section>
  );
}
